import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Renderer } from 'react-pretext-editor'
import Splash from '../../shared/components/Splash'
import { CMS_API, formatDate, buildExcerpt, getPreviewImage, setMeta } from './utils'

const fonts = [
  { name: 'Lato', bodyFont: '16px Lato, sans-serif' },
  { name: 'Georgia', bodyFont: '16px Georgia, serif', bodyLineHeight: 28 },
]

const initialFonts = [
  { name: 'Floral Capitals', fontFamily: 'FloralCapitals, serif' },
]

export default function BlogPost({ slug }) {
  const [post, setPost] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${CMS_API}/posts/${encodeURIComponent(slug)}`)
        if (res.status === 404) {
          setError('not_found')
          return
        }
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const data = await res.json()
        setPost(data)
        const previewImg = getPreviewImage(data)
        setMeta({
          title: data.title,
          description: buildExcerpt(data.blocks, 160),
          image: previewImg?.url,
          type: 'article',
        })
      } catch (e) {
        setError(e.message || 'error')
      }
    }
    load()
  }, [slug])

  if (error === 'not_found') return <><Splash /><Wrap><h1>Ikke funnet</h1><p>Denne bloggposten finnes ikke.</p></Wrap></>
  if (error) return <><Splash /><Wrap><h1>Feil</h1><p>Kunne ikke laste posten.</p></Wrap></>
  if (!post) return <><Splash /><Wrap><h1>Laster…</h1></Wrap></>

  return (
    <>
    <Splash />
    <Wrap>
      <Article>
        <h1>{post.title}</h1>
        <PostMeta>{formatDate(post.created_at)}</PostMeta>
        <PretextRoot>
          <Renderer
            blocks={post.blocks || []}
            layout={post.layout || { images: [] }}
            availableFonts={fonts}
            availableInitialFonts={initialFonts}
          />
        </PretextRoot>
      </Article>
    </Wrap>
    </>
  )
}

const Wrap = styled.div`
  padding: 20px;
  text-align: left;
`

const Article = styled.article`
  h1 { margin-bottom: 6px; }
`

const PostMeta = styled.div`
  font-size: 0.85em;
  color: #888;
  margin-bottom: 30px;
`

const PretextRoot = styled.div`
  margin-top: 30px;
  padding: 0 1px;
  img { margin: 0 !important; max-width: none !important; }
`
